// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const EmploymentBases = {
  "FULLTIME": "FULLTIME",
  "TEMPFULLTIME": "TEMPFULLTIME",
  "PARTTIME": "PARTTIME",
  "TEMPPARTTIME": "TEMPPARTTIME",
  "CONTRACT": "CONTRACT"
};

const PurchaseStages = {
  "RESEARCHING": "RESEARCHING",
  "VIEWING": "VIEWING",
  "OFFERMADE": "OFFERMADE",
  "OFFERACCEPTED": "OFFERACCEPTED"
};

const MortgageTypes = {
  "REFINANCE": "REFINANCE",
  "PURCHASE": "PURCHASE"
};

const PropertyTypes = {
  "DETACHED": "DETACHED",
  "SEMIDETACHED": "SEMIDETACHED",
  "TERRACE": "TERRACE",
  "APARTMENT": "APARTMENT",
  "FLAT": "FLAT"
};

const DebtTypes = {
  "CREDITCARD": "CREDITCARD",
  "STORECARD": "STORECARD",
  "LOAN": "LOAN",
  "OVERDRAFT": "OVERDRAFT"
};

const AssetTypes = {
  "SAVING": "SAVING",
  "INVESTMENT": "INVESTMENT"
};

const Frequencies = {
  "WEEKLY": "WEEKLY",
  "FORTNIGHTLY": "FORTNIGHTLY",
  "MONTHLY": "MONTHLY",
  "QUARTERLY": "QUARTERLY",
  "YEARLY": "YEARLY",
  "STATIC": "STATIC",
  "OCCASIONALLY": "OCCASIONALLY"
};

const EmploymentTypes = {
  "EMPLOYED": "EMPLOYED",
  "SELFEMPLOYED": "SELFEMPLOYED",
  "HOMEMAKER": "HOMEMAKER",
  "STUDENT": "STUDENT"
};

const PersonalTitles = {
  "MR": "MR",
  "MRS": "MRS",
  "MISS": "MISS",
  "DR": "DR"
};

const PersonalMaritalStatuses = {
  "SINGLE": "SINGLE",
  "COHABITING": "COHABITING",
  "MARRIED": "MARRIED",
  "REMARRIED": "REMARRIED",
  "SEPARATED": "SEPARATED",
  "DIVORCED": "DIVORCED",
  "WIDOWED": "WIDOWED"
};

const PersonalAccommodationSituations = {
  "OWNED": "OWNED",
  "RENTED": "RENTED",
  "RELATIVES": "RELATIVES",
  "OTHER": "OTHER"
};

const PropertyIntendedUses = {
  "FIRSTTIME": "FIRSTTIME",
  "MOVING": "MOVING",
  "BUYTOLET": "BUYTOLET",
  "HOLIDAYHOME": "HOLIDAYHOME"
};

const UploadStatuses = {
  "PENDING": "PENDING",
  "ACCEPTABLE": "ACCEPTABLE",
  "REJECTED": "REJECTED",
  "UPLOADING": "UPLOADING"
};

const ApplicationStages = {
  "SETUP": "SETUP",
  "APPLY": "APPLY",
  "TASKS": "TASKS",
  "CALCULATE": "CALCULATE"
};

const IncomeSources = {
  "SALARY": "SALARY",
  "DRAWINGS": "DRAWINGS"
};

const { PublicCouncils, AdminMortgageTasks, AdminMortgageNotes, AdminLender, PublicLenderRate, UserMortgageProgress, UserMortgageUploads, UserMortgage, UserMortgageRequirement, UserMortgageProperty, UserMortgageExisting, UserMortgageNeeds, UserApplicant, UserApplicantPersonal, UserApplicantIncome, UserApplicantFinancial, UserApplicantEmployment, UserApplicantTax, UserApplicantAsset, UserApplicantProperty, UserApplicantDebt } = initSchema(schema);

export {
  PublicCouncils,
  AdminMortgageTasks,
  AdminMortgageNotes,
  AdminLender,
  PublicLenderRate,
  UserMortgageProgress,
  UserMortgageUploads,
  UserMortgage,
  UserMortgageRequirement,
  UserMortgageProperty,
  UserMortgageExisting,
  UserMortgageNeeds,
  UserApplicant,
  UserApplicantPersonal,
  UserApplicantIncome,
  UserApplicantFinancial,
  UserApplicantEmployment,
  UserApplicantTax,
  UserApplicantAsset,
  UserApplicantProperty,
  UserApplicantDebt,
  EmploymentBases,
  PurchaseStages,
  MortgageTypes,
  PropertyTypes,
  DebtTypes,
  AssetTypes,
  Frequencies,
  EmploymentTypes,
  PersonalTitles,
  PersonalMaritalStatuses,
  PersonalAccommodationSituations,
  PropertyIntendedUses,
  UploadStatuses,
  ApplicationStages,
  IncomeSources
};